import { PropsWithChildren } from 'react';

import { EmptyState, EmptyStateSizes, SIZES_EMPTY_STATE } from '@partoohub/modular-components';

import { useTranslation } from 'react-i18next';

import { PlaceholderCategory, PlaceholderType } from './DynamicPlaceholder.types';
import { getIconComponent, getIllustrationComponent, getPlaceholderConfig } from './helper';

interface DynamicPlaceholderProps {
    category?: PlaceholderCategory;
    size?: EmptyStateSizes;
    type?: PlaceholderType;
    style?: React.CSSProperties;
}

export const DynamicPlaceholder = ({
    category = PlaceholderCategory.NoData,
    type,
    size,
    style,
    children,
}: PropsWithChildren<DynamicPlaceholderProps>) => {
    const { t } = useTranslation();
    const {
        title,
        description,
        illustration,
        icon,
        size: sizeItem,
        partoorobot,
    } = getPlaceholderConfig(category, type);
    const sizeKey = (sizeItem ?? size ?? 'medium') as keyof typeof SIZES_EMPTY_STATE;
    const sizeNumber = SIZES_EMPTY_STATE[sizeKey].imageHeight;
    return (
        <div style={style} data-partoorobot={partoorobot}>
            <EmptyState
                title={title ? t(title) : undefined}
                description={description ? t(description) : undefined}
                image={
                    illustration
                        ? getIllustrationComponent(illustration, sizeNumber)
                        : icon
                          ? getIconComponent(icon, sizeNumber)
                          : undefined
                }
                size={size}
            >
                {children}
            </EmptyState>
        </div>
    );
};
